import { Box, Divider, LinearProgress, Paper, Tab, Tabs } from '@mui/material';

import React, {
  useEffect,
  useState,
  useRef,
  useImperativeHandle,
  forwardRef,
} from 'react';

import { useNavigate } from 'react-router-dom';
import { useStore } from '../../utils/store';
import Constants from '../../utils/constants';
import HttpServices from '../../services/HttpService';

import { useCrewCalender } from './StoreCrewCalendar';
import BillableView from './parts/BillableView';
import SimpleDialogComponent from '../../components/SimpleDialogComponent';
import SimpleAutoCompleteTextFieldComponent from '../../components/form/SimpleAutoCompleteTextFieldComponent';
import ButtonComponent from '../../components/form/ButtonComponent';
import TextFieldAreaComponent from '../../components/form/TextFieldAreaComponent';
// import ResourcesView from './parts/ResourcesView';
import AlertMessageComponent from '../../components/AlertMessageComponent';
import ShiftSaveButtons from './parts/SaveButtons';
import tabStore from './tabStore';

import ResourcesView from './parts/ResourcesView';
interface ResourcesProps {
  currentRecord: any;
  goBack: () => void;
  goRefresh: () => void;
  updateShiftStatus: (record: any) => void;
}
export type ResourceRef = {
  handleSave: (type: any) => void;
};
const Resources = forwardRef<ResourceRef, ResourcesProps>(
  ({ currentRecord, goBack, goRefresh, updateShiftStatus }, ref) => {
    const getInputKey = (field: any, index: any) => `${field}_${index}`;

    const inputRefs = useRef<any>([]);
    const [focusedField, setFocusedField] = useState<any>(null);

    const tabLabels = ['Billable Description', 'Resource Item'];
    const [expandRowState, setExpandRowState] = React.useState<any[]>([]);
    const [removablesDetails, setRemovablesDetails] = React.useState<any>({
      mainIndex: -1,
      detailIndex: -1,
    });
    const [removablesResource, setRemovablesResource] =
      React.useState<number>(-1);
    const [confirmDailogOpen, setConfirmDailogOpen] = useState<boolean>(false);
    useImperativeHandle(ref, () => ({
      handleSave,
    }));
    const [tabIndex, setTabIndex] = useState(0);

    const isInitialLoad = useRef(true);

    const { quoteDetails, resourceListItems } = useCrewCalender();
    const [addNoteDialogOpen, setAddNoteDialogOpen] = useState<boolean>(false);
    const [resourceNoteDialogOpen, setResourceNoteDialogOpen] =
      useState<boolean>(false);
    const [currentBillableIndex, setCurrentBillableIndex] =
      useState<number>(-1);
    const [currentResourceIndex, setCurrentResourceIndex] =
      useState<number>(-1);
    const [currentBillableDetailIndex, setCurrentBillableDetailIndex] =
      useState<number>(-1);
    const [currentNote, setCurrentNote] = useState<string>('');
    const [currentResource, setCurrentResource] = useState<any>(null);
    const [currentResourceNote, setCurrentResourceNote] = useState<any>('');
    const [billableDialogOpen, setBillableDialogOpen] =
      useState<boolean>(false);
    const [resourceDialogOpen, setResourceDialogOpen] =
      useState<boolean>(false);
    const [currentBillable, setCurrentBillable] = useState<any>(null);

    const [billableFormItems, setBillableFormItems] = useState<any[]>([]);
    const [quoteBillableItems, setQuoteBillableItems] = useState<any[]>([]);
    const [crewList, setCrewList] = useState<any[]>([]);
    const [inProgress, setInProgress] = useState(false);
    const [processing, setProcessing] = useState<boolean>(false);
    const [publishing, setPublishing] = useState<boolean>(false);
    const [resourceItems, setResourceItems] = useState<any[]>([]);

    const { getAdmin } = useStore();
    const navigate = useNavigate();
    const [resourceList, setResourceList] = useState<any[]>(resourceListItems);
    const [httpError, setHttpError] = useState({
      message: '',
      open: false,
    });
    const handleArrow = async (index: number) => {
      setExpandRowState((prevItems: any) =>
        prevItems.includes(index)
          ? prevItems.filter((item: any) => item !== index)
          : [...prevItems, index]
      );
    };
    useEffect(() => {
      if (focusedField && inputRefs.current[focusedField]) {
        inputRefs.current[focusedField]?.focus();
      }
    }, [resourceItems, billableFormItems]);
    const loadData = async () => {
      if (currentRecord) {
        setInProgress(true);
        if (!quoteDetails) {
        } else {
          if (quoteDetails.billables)
            setQuoteBillableItems(
              quoteDetails.billables.length > 0
                ? quoteDetails.billables.sort((a: any, b: any) =>
                    a.name.localeCompare(b.name)
                  )
                : quoteDetails.billables
            );
        }
        if (resourceListItems.length > 0) {
          setResourceList(resourceListItems);
        } else {
          await getResourceList();
        }

        handleResourcesAndBillables();
        setInProgress(false);
      }
    };
    const getResourceList = async () => {
      try {
        const response = await HttpServices.get(
          Constants.apiURL + Constants.resourcesURL,
          { headers: { Authorization: 'Bearer ' + getAdmin() } },
          { isActive: '1' }
        );
        if (response.success) {
          const resourceRecords = response.data.paginateRecords;
          if (resourceRecords.length > 0) {
            setResourceList(resourceRecords);
          }
        }
        console.log('GET Response:', response);
      } catch (error: any) {
        console.error(`Error fetching data:`, error);
      }
    };
    const handleResourcesAndBillables = () => {
      let shiftResources: any[] = currentRecord.shiftResources;
      let shiftBillables: any[] = currentRecord.shiftBillables;
      shiftResources = shiftResources.map((item) => ({
        ...item,
        planStartTime: item.planStartTime
          ? item.planStartTime.substring(0, 5)
          : null,
        planEndTime: item.planEndTime ? item.planEndTime.substring(0, 5) : null,
        planTotalTime: calculateTimeDiff(item.planStartTime, item.planEndTime),
        actualStartTime: item.actualStartTime
          ? item.actualStartTime.substring(0, 5)
          : null,
        actualEndTime: item.actualEndTime
          ? item.actualEndTime.substring(0, 5)
          : null,
        actualTotalTime: calculateTimeDiff(
          item.actualStartTime,
          item.actualEndTime
        ),
        reviewStartTime: item.reviewStartTime
          ? item.reviewStartTime.substring(0, 5)
          : null,
        reviewEndTime: item.reviewEndTime
          ? item.reviewEndTime.substring(0, 5)
          : null,
        reviewTotalTime: calculateTimeDiff(
          item.reviewStartTime,
          item.reviewEndTime
        ),
      }));
      shiftBillables = shiftBillables.map((item) => ({
        ...item,
        resources: item.resources.map((detailItem: any) => ({
          ...detailItem,
          planStartTime: detailItem.planStartTime
            ? detailItem.planStartTime.substring(0, 5)
            : null,
          planEndTime: detailItem.planEndTime
            ? detailItem.planEndTime.substring(0, 5)
            : null,
          planTotalTime: calculateTimeDiff(
            detailItem.planStartTime,
            detailItem.planEndTime
          ),
          reviewStartTime: detailItem.reviewStartTime
            ? detailItem.reviewStartTime.substring(0, 5)
            : null,
          reviewEndTime: detailItem.reviewEndTime
            ? detailItem.reviewEndTime.substring(0, 5)
            : null,
          reviewTotalTime: calculateTimeDiff(
            detailItem.reviewStartTime,
            detailItem.reviewEndTime
          ),
          actualStartTime: detailItem.actualStartTime
            ? detailItem.actualStartTime.substring(0, 5)
            : null,
          actualEndTime: detailItem.actualEndTime
            ? detailItem.actualEndTime.substring(0, 5)
            : null,
          actualTotalTime: calculateTimeDiff(
            detailItem.actualStartTime,
            detailItem.actualEndTime
          ),
        })),
      }));
      setResourceItems(shiftResources);
      setBillableFormItems(shiftBillables);
    };
    const calculateTimeDiff = (start: any, end: any) => {
      if (!start || !end) {
        return '-';
      }
      const [startH, startM] = start.split(':').map(Number);
      const [endH, endM] = end.split(':').map(Number);

      let startMinutes = startH * 60 + startM;
      let endMinutes = endH * 60 + endM;

      // if end time is smaller, assume it’s next day
      if (endMinutes < startMinutes) {
        endMinutes += 24 * 60;
      }

      const diff = endMinutes - startMinutes;
      let hours = Math.floor(diff / 60);
      let minutes: any = diff % 60;
      minutes = Math.round(minutes);
      if (minutes <= 0) {
        minutes = '';
      } else {
        minutes = minutes.toString() + 'm';
      }
      if (minutes === '' && hours === 0) {
        return '-';
      }
      return `${hours}h ${minutes}`;
    };
    useEffect(() => {
      if (currentRecord) {
        loadData();
      }
    }, [currentRecord]);
    const removeResourceItem = (index: any) => {
      setResourceItems((prevItems) => {
        const newItems = [...prevItems];
        newItems.splice(index, 1);
        return newItems;
      });
      setConfirmDailogOpen(false);
      setRemovablesResource(-1);
      tabStore.updateField('tab1Field', 'updated');
    };

    const handleResourceChange = (value: any, index: number, type: string) => {
      setResourceItems((prevItems) => {
        // Create a copy of the current state
        const updatedItems = [...prevItems];
        tabStore.updateField('tab1Field', 'updated');
        if (
          type === 'planStartTime' ||
          type === 'planEndTime' ||
          type === 'reviewStartTime' ||
          type === 'reviewEndTime'
        ) {
          let calculatedType = 'planTotalTime';
          let totalTime = '-';
          if (type === 'planStartTime' || type === 'planEndTime') {
            if (type === 'planStartTime') {
              totalTime = calculateTotalTime(
                value,
                updatedItems[index]['planEndTime']
              );
            }
            if (type === 'planEndTime') {
              totalTime = calculateTotalTime(
                updatedItems[index]['planStartTime'],
                value
              );
            }
            calculatedType = 'planTotalTime';
          }
          if (type === 'reviewStartTime' || type === 'reviewEndTime') {
            if (type === 'reviewStartTime') {
              totalTime = calculateTotalTime(
                value,
                updatedItems[index]['reviewEndTime']
              );
            }
            if (type === 'reviewEndTime') {
              totalTime = calculateTotalTime(
                updatedItems[index]['reviewStartTime'],
                value
              );
            }
            calculatedType = 'reviewTotalTime';
          }
          updatedItems[index] = {
            ...updatedItems[index],
            [type]: value,
            [calculatedType]: totalTime,
          };
        } else {
          setFocusedField(getInputKey(type, index));
          updatedItems[index] = {
            ...updatedItems[index],
            [type]: value,
          };
        }
        return updatedItems;
      });
    };
    const handleBillableDetailChange = (
      value: any,
      index: number,
      type: string,
      detailIndex: number
    ) => {
      setBillableFormItems((prevItems) => {
        // Create a copy of the current state
        const updatedItems = [...prevItems];
        tabStore.updateField('tab1Field', 'updated');
        if (
          type === 'planStartTime' ||
          type === 'planEndTime' ||
          type === 'reviewStartTime' ||
          type === 'reviewEndTime'
        ) {
          let calculatedType = 'planTotalTime';
          let totalTime = '-';
          if (type === 'planStartTime' || type === 'planEndTime') {
            if (type === 'planStartTime') {
              totalTime = calculateTotalTime(
                value,
                updatedItems[index]['resources'][detailIndex]['planEndTime']
              );
            }
            if (type === 'planEndTime') {
              totalTime = calculateTotalTime(
                updatedItems[index]['resources'][detailIndex]['planStartTime'],
                value
              );
            }
            calculatedType = 'planTotalTime';
          }
          if (type === 'reviewStartTime' || type === 'reviewEndTime') {
            if (type === 'reviewStartTime') {
              totalTime = calculateTotalTime(
                value,
                updatedItems[index]['resources'][detailIndex]['reviewEndTime']
              );
            }
            if (type === 'reviewEndTime') {
              totalTime = calculateTotalTime(
                updatedItems[index]['resources'][detailIndex][
                  'reviewStartTime'
                ],
                value
              );
            }
            calculatedType = 'reviewTotalTime';
          }
          updatedItems[index]['resources'][detailIndex] = {
            ...updatedItems[index]['resources'][detailIndex],
            [type]: value,
            [calculatedType]: totalTime,
          };
        } else {
          console.log(
            getInputKey(type, index + '-' + detailIndex) + '-----------'
          );
          setFocusedField(getInputKey(type, index + '-' + detailIndex));
          updatedItems[index]['resources'][detailIndex] = {
            ...updatedItems[index]['resources'][detailIndex],
            [type]: value,
          };
        }
        return updatedItems;
      });
    };
    const calculateTotalTime = (startTime: any, endTime: any) => {
      if (startTime && endTime) {
        const [startHours, startMinutes] = startTime.split(':').map(Number);
        const [endHours, endMinutes] = endTime.split(':').map(Number);

        let start: any = new Date();
        start.setHours(startHours, startMinutes, 0);

        let end: any = new Date();
        end.setHours(endHours, endMinutes, 0);

        let diff = (end - start) / 1000 / 60; // difference in minutes

        if (diff < 0) diff += 24 * 60; // handles endTime being next day

        const hours = Math.floor(diff / 60);
        const minutes = diff % 60;

        return `${hours}hrs, ${minutes}min `;
      } else {
        return '--';
      }
    };
    const AddBillableItem = () => {
      const index: any = quoteBillableItems.findIndex(
        (item: any) =>
          item.billableItemId.toString() ===
          currentBillable.billableItemId.toString()
      );

      if (index !== -1) {
        const indexData = billableFormItems.findIndex((item: any) =>
          item.billableItemId
            ? item.billableItemId.toString() ===
              currentBillable.billableItemId.toString()
            : item.billableItemId.toString() === currentBillable.id.toString()
        );
        if (indexData === -1) {
          setBillableFormItems((prevItems) => {
            const newItems = [...prevItems];

            const isExists = newItems.find(
              (item: any) =>
                item.billableItemId === quoteBillableItems[index].billableItemId
            );
            if (!isExists) {
              newItems.push(getFormattedBillables(quoteBillableItems[index]));
            }

            return newItems;
          });
        }
      }
      tabStore.updateField('tab1Field', 'updated');
      setBillableDialogOpen(false);
    };
    const handleBillableAdd = (e: any, dataValue: any) => {
      setCurrentBillable(dataValue);
    };
    const handleResourceAdd = (e: any, dataValue: any) => {
      setCurrentResource(dataValue);
    };
    const AddResourceItem = () => {
      const index: any = resourceList.findIndex(
        (item) => item.id === currentResource.id
      );

      let newItems: any;
      if (index !== -1) {
        setResourceItems((prevItems) => {
          newItems = [...prevItems];

          const isExists = newItems.find(
            (item: any) => item.resourcesId === resourceList[index].id
          );
          if (!isExists) {
            newItems.push(getFormattedResource(resourceList[index]));
          }

          return newItems;
        });
      }
      setResourceDialogOpen(false);
      tabStore.updateField('tab1Field', 'updated');
    };
    const getFormattedBillables = (billableItem: any) => {
      return {
        billableItemId: billableItem.billableItemId,
        name: billableItem.name,
        resources: billableItem.resources.map((resource: any) =>
          getFormattedResource(resource)
        ),
      };
    };
    const getFormattedResource = (resource: any) => {
      return {
        resourcesId: resource.resourcesId ? resource.resourcesId : resource.id,
        name: resource.name,
        planQuantity: 1,
        reviewQuantity: null,
        actualQuantity: null,
        planStartTime: '00:00',
        planEndTime: '00:00',
        planTotalTime: null,
        reviewStartTime: null,
        reviewEndTime: null,
        reviewTotalTime: null,
        actualStartTime: null,
        actualEndTime: null,
        actualTotalTime: null,
        notes: '',
      };
    };
    const dialogContentResources = () => {
      return (
        <div className="row mb-3 mt-2">
          <div style={{ width: '600px' }}>
            <SimpleAutoCompleteTextFieldComponent
              name="resourceLstselect"
              value={currentResource}
              isRequired={false}
              errorStr={''}
              keyName="resourceLstselect"
              label="Resource Items"
              onChange={handleResourceAdd}
              items={resourceList}
            />
          </div>
          <div className="col">
            <ButtonComponent
              keyName={'addBtn'}
              errors={[]}
              onClick={AddResourceItem}
              label={'Add'}
            />
          </div>
        </div>
      );
    };
    const dialogConfirmation = () => {
      return (
        <Box sx={{ width: '450px' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '20px',
            }}
          >
            <ButtonComponent
              errors={[]}
              keyName="okbuttonconfirm"
              label="Yes"
              onClick={() => {
                if (
                  removablesDetails.mainIndex !== -1 &&
                  removablesDetails.detailIndex !== -1
                ) {
                  removeBillableDetailsItem(
                    removablesDetails.mainIndex,
                    removablesDetails.detailIndex
                  );
                }
                if (removablesResource !== -1) {
                  removeResourceItem(removablesResource);
                }
              }}
            />
            <ButtonComponent
              errors={[]}
              keyName="cancelbuttonconfirm"
              label="No"
              onClick={() => {
                setConfirmDailogOpen(false);
                setRemovablesDetails({
                  mainIndex: -1,
                  detailIndex: -1,
                });
                setRemovablesResource(-1);
              }}
            />
          </Box>
        </Box>
      );
    };
    const dialogBillableContent = () => {
      return (
        <div className="row mb-3 mt-2">
          <div style={{ width: '400px' }}>
            <SimpleAutoCompleteTextFieldComponent
              name="billableAutoSelect"
              value={currentBillable}
              isRequired={false}
              errorStr={''}
              keyName="billableAutoSelect"
              label="Billable Items"
              onChange={handleBillableAdd}
              items={quoteBillableItems}
            />
          </div>
          <div className="col">
            <ButtonComponent
              keyName={'addBtn'}
              errors={[]}
              onClick={AddBillableItem}
              label={'Add'}
            />
          </div>
        </div>
      );
    };
    const NoteDialogContent = (type: string) => {
      return (
        <div className="row mb-3 mt-2">
          <div style={{ width: '600px' }}>
            <TextFieldAreaComponent
              name={'notebox_'}
              value={
                type === 'resourceNote' ? currentResourceNote : currentNote
              }
              isRequired={false}
              errorStr={''}
              minRows={7}
              keyName={'notebox_'}
              label="Note"
              onChange={(e: any) => {
                type === 'resourceNote'
                  ? setCurrentResourceNote(e.target.value)
                  : setCurrentNote(e.target.value);
              }}
            />
          </div>
          <div className="col" style={{ textAlign: 'right' }}>
            <ButtonComponent
              keyName={'addBtn'}
              errors={[]}
              onClick={() => {
                handleNoteSave(type);
              }}
              loading={false}
              label={'Save'}
            />
          </div>
        </div>
      );
    };
    const handleNoteSave = async (type: string) => {
      if (type === 'billableNote') {
        if (currentBillableDetailIndex !== -1 && currentBillableIndex !== -1) {
          setBillableFormItems((prevItems) => {
            // Create a copy of the current state
            const updatedItems = [...prevItems];
            updatedItems[currentBillableIndex]['resources'][
              currentBillableDetailIndex
            ] = {
              ...updatedItems[currentBillableIndex]['resources'][
                currentBillableDetailIndex
              ],
              ['notes']: currentNote,
            };
            return updatedItems;
          });
          setAddNoteDialogOpen(false);
          setCurrentBillableIndex(-1);
          setCurrentBillableDetailIndex(-1);
          setCurrentNote('');
        }
      }
      if (type === 'resourceNote') {
        if (currentResourceIndex !== -1) {
          setResourceItems((prevItems) => {
            // Create a copy of the current state
            const updatedItems = [...prevItems];
            updatedItems[currentResourceIndex] = {
              ...updatedItems[currentResourceIndex],
              ['notes']: currentResourceNote,
            };
            return updatedItems;
          });
          setResourceNoteDialogOpen(false);
          setCurrentResourceIndex(-1);
          setCurrentResourceNote('');
        }
      }
    };
    const removeDetailsItem = (index: any, detailIndex: any) => {
      setRemovablesDetails({ mainIndex: index, detailIndex: detailIndex });
      setConfirmDailogOpen(true);
    };
    const removeResourceItemAlert = (index: any) => {
      setRemovablesResource(index);
      setConfirmDailogOpen(true);
    };
    const removeBillableDetailsItem = (index: any, detailIndex: any) => {
      if (billableFormItems[index].resources.length === 1) {
        removeItem(index);
        setConfirmDailogOpen(false);
        return;
      }
      setBillableFormItems((prevItems) => {
        // Create a deep copy of the state array
        const newItems = prevItems.map((item, i) => {
          if (i === index) {
            return {
              ...item,
              resources: item.resources.filter(
                (_: any, dIndex: any) => dIndex !== detailIndex
              ),
            };
          }
          return item;
        });
        if (newItems[index].resources.length === 0) {
          removeItem(index);
        }

        return newItems; // Return the updated array
      });
      setConfirmDailogOpen(false);
      tabStore.updateField('tab1Field', 'updated');
    };
    const removeItem = (index: any) => {
      setBillableFormItems((prevItems) => {
        const newItems = [...prevItems];
        newItems.splice(index, 1);

        return newItems;
      });
      tabStore.updateField('tab1Field', 'updated');
    };
    const TabContent = () => {
      return (
        <Box>
          {inProgress && (
            <Box sx={{ width: '100%', textAlign: 'center' }}>
              <LinearProgress />
            </Box>
          )}
          {tabIndex === 0 && (
            <BillableView
              inputRefs={inputRefs}
              billableFormItems={billableFormItems}
              expandRowState={expandRowState}
              handleArrow={handleArrow}
              handleBillableDetailChange={handleBillableDetailChange}
              handleBillableDialog={() => {
                setBillableDialogOpen(true);
              }}
              removeDetailsItem={removeDetailsItem}
              editNoteDialog={(index: number, detailIndex: number) => {
                setCurrentBillableIndex(index);
                setCurrentBillableDetailIndex(detailIndex);
                setAddNoteDialogOpen(true);
                setCurrentNote(
                  billableFormItems[index]['resources'][detailIndex]['notes']
                );
              }}
              shiftStatusId={currentRecord.shiftStatusId}
            />
          )}
          {tabIndex === 1 && (
            <ResourcesView
              inputRefs={inputRefs}
              shiftStatusId={currentRecord.shiftStatusId}
              resourceItems={resourceItems}
              handleResourceChange={handleResourceChange}
              handleResourceDialog={() => {
                setResourceDialogOpen(true);
              }}
              removeItem={removeResourceItemAlert}
              editNoteDialog={(index: number) => {
                setCurrentResourceIndex(index);
                setCurrentResourceNote(resourceItems[index]['notes']);
                setResourceNoteDialogOpen(true);
              }}
              viewOnly={false}
            />
          )}
        </Box>
      );
    };

    const changeTabHandler = async (newIndex: number) => setTabIndex(newIndex);
    const handleSave = async (type: number) => {
      const shiftReq: any = {
        shiftId: currentRecord.shiftId,
        billables: billableFormItems,
        resources: resourceItems,
      };
      if (type === 0 || 3) {
        setProcessing(true);
      } else {
        setPublishing(true);
      }
      tabStore.updateField('tab1Field', '');
      const endpoint = Constants.apiURL + Constants.shiftURL + '/billables';

      let response: any;

      try {
        if (currentRecord) {
          response = await HttpServices.post(endpoint, shiftReq, {
            headers: { Authorization: `Bearer ${getAdmin()}` },
          });
        }
        //  if (response.success) {

        setHttpError({
          open: true,
          message: 'Saved successfully',
        });

        if (type === 3 || type === 4 || type === 1) {
          updateShiftStatus({
            shiftId: currentRecord.shiftId,
            newShiftStatusId: type,
          });
          if (type === 4 || 1) {
            goBack();
          }
        } else {
          goRefresh();
        }
        return true;
        //}
      } catch (error: any) {
        console.error(`PATCH Error:`, error);
        setHttpError({
          message: error.message,
          open: true,
        });
        return true;
      } finally {
        setProcessing(false);
        setPublishing(false);
        return true;
      }
    };
    const a11yProps = (index: number) => {
      return {
        id: `tabResources-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
      };
    };

    return (
      <Paper sx={{ width: '100%' }} elevation={0} className="mt-4">
        <Box
          sx={{
            padding: '24px 16px 16px 16px',
            mb: 2,
            display: 'grid',
            gap: '32px',
          }}
        >
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: '0px' }}>
              <Tabs
                value={tabIndex}
                onChange={(event: React.SyntheticEvent, newValue: number) => {
                  changeTabHandler(newValue);
                }}
                aria-label="crew tabs"
              >
                {tabLabels.map((label: any, index: number) => {
                  return (
                    <Tab
                      key={label + '_' + index}
                      disabled={inProgress}
                      label={label}
                      {...a11yProps(index)}
                    />
                  );
                })}
              </Tabs>
            </Box>
            <Box>
              <TabContent />
            </Box>
          </Box>

          <Divider />
          {
            <ShiftSaveButtons
              processing={processing}
              publishing={publishing}
              handleSave={handleSave}
              shiftStatus={currentRecord ? currentRecord.shiftStatusId : 0}
            />
          }
          {
            <SimpleDialogComponent
              title={'Billables'}
              dialogContent={dialogBillableContent()}
              open={billableDialogOpen}
              handleClose={() => {
                setBillableDialogOpen(false);
              }}
            />
          }
          {
            <SimpleDialogComponent
              title={'Billable Note'}
              dialogContent={NoteDialogContent('billableNote')}
              open={addNoteDialogOpen}
              handleClose={() => {
                setAddNoteDialogOpen(false);
              }}
            />
          }
          {
            <SimpleDialogComponent
              title={'Resources'}
              dialogContent={dialogContentResources()}
              open={resourceDialogOpen}
              handleClose={() => {
                setResourceDialogOpen(false);
              }}
            />
          }
          {
            <SimpleDialogComponent
              title={'Resource Note'}
              dialogContent={NoteDialogContent('resourceNote')}
              open={resourceNoteDialogOpen}
              handleClose={() => {
                setResourceNoteDialogOpen(false);
              }}
            />
          }
          {
            <SimpleDialogComponent
              title={'Confirm removal?'}
              dialogContent={dialogConfirmation()}
              open={confirmDailogOpen}
              handleClose={() => {
                setConfirmDailogOpen(false);
                setRemovablesDetails({ mainIndex: -1, detailIndex: -1 });
                setRemovablesResource(-1);
              }}
            />
          }
          <AlertMessageComponent
            type={'success'}
            open={httpError.open}
            handleClose={() => {
              setHttpError({ open: false, message: '' });
            }}
            message={httpError.message}
          />
        </Box>
      </Paper>
    );
  }
);

export default Resources;

// export default ResourcesView;
const boxStyle = {
  marginBottom: '15px',
};

const borderStyleRight = {
  borderRight: '1px solid #edeeed',
};

const borderStyleLeft = {
  borderLeft: ' 1px solid  #edeeed',
};
